import ReactModal from 'react-modal';
import General from '../utils/GeneralUtils';
import UniversalTag from './UniversalTag';
import './EmailVerificationSlideout.scss';

const EMAIL_TYPE_STATUSES = [
  {
    key: 'PERSONAL',
    description: 'This email address appears to be a personal inbox for this contact (e.g., john.smith@school.edu).',
  },
  {
    key: 'ROLE',
    description: 'This email address is a role-based or generic inbox that may be shared (e.g., principal@school.edu, info@school.edu).',
  },
];

interface EmailTypeSlideoutProps {
  isOpen: boolean;
  onClose: () => void;
}

export function EmailTypeSlideout({ isOpen, onClose }: EmailTypeSlideoutProps) {
  return (
    <ReactModal
      isOpen={isOpen}
      shouldCloseOnEsc={true}
      shouldCloseOnOverlayClick={true}
      onRequestClose={onClose}
      style={General.getSliderDefaults({ width: 'min(90vw, 450px)' })}
      parentSelector={General.getModalRoot}
    >
      <div className="email-verification-slideout">
        <div className="header">
          <h3>Email Type</h3>
        </div>

        <div className="section intro">
          <p>Indicates whether the email address appears to be a personal inbox or a shared/role-based inbox.</p>
        </div>

        <div className="section all-statuses">
          <table>
            <tbody>
              {EMAIL_TYPE_STATUSES.map((statusInfo) => (
                <tr key={statusInfo.key}>
                  <td className="status-cell">
                    <UniversalTag category={statusInfo.key} />
                  </td>
                  <td className="desc">{statusInfo.description}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </ReactModal>
  );
}
